import styled from 'styled-components';

const ModalBody = styled.section`
  margin: 60px auto;
  position: relative;
  border-radius: 24px;
  background-color: var(--elevation-high);

  box-shadow: 0 0 0 0.5px var(--border-muted), 0 18px 36px rgba(79, 77, 68, 0.08),
    0 9px 18px rgba(79, 77, 68, 0.07), 0 3px 6px rgba(79, 77, 68, 0.05);

  display: flex;
  flex-direction: column;

  width: ${(props) => {
    switch (props.size) {
      case 'xs':
        return '320px';
      case 'sm':
        return '480px';
      case 'md':
        return '640px';
      case 'lg':
        return '1200px';
      default:
        return '100%';
    }
  }};

  @media (max-width: 768px) {
    width: 100%;
    border-radius: 0;
    margin: 0;
  }
`;

export { ModalBody };
